export function applyLoginPageBody() {
  document.body.className = "t-loginPage-body t-loginPage-body--split";
  document.body.id = "";
  document.body.background = "";
  document.body.style.backgroundImage = "";
  document.body.style.backgroundSize = "";
  document.body.style.backgroundRepeat = "";
  document.body.style.backgroundPosition = "";
}
